import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import {
  DesktopSidebar,
  MobileSidebar,
  SIDEBAR_SHRINK_PREFERENCE_KEY,
  SidebarShrinkContext,
} from "./Sidebar";

const ManagementLayout = () => {
  const [shrinked, setShrinked] = useState(
    localStorage.getItem(SIDEBAR_SHRINK_PREFERENCE_KEY) === "true",
  );
  
  useEffect(() => {
    localStorage.setItem(
      SIDEBAR_SHRINK_PREFERENCE_KEY,
      shrinked ? "true" : "false",
    );
  }, [shrinked]);
  
  return (
    <SidebarShrinkContext.Provider value={{ shrinked, setShrinked }}>
      <div className="flex h-screen overflow-hidden bg-[#F8F8F8]">
        {/* Mobile Sidebar - only visible on small screens */}
        <div className="block 2xl:hidden">
          <MobileSidebar />
        </div>
        
        {/* Desktop Sidebar - only visible on large screens */}
        <div className="hidden 2xl:block">
          <DesktopSidebar />
        </div>
        
        {/* Main content container */}
        <div className="relative flex flex-1 flex-col overflow-hidden 2xl:ml-64">
          <Navbar />
          <main className="flex-1 overflow-y-auto overflow-x-hidden">
            <section className="p-4">
              <Outlet />
            </section>
          </main>
        </div>
      </div>
    </SidebarShrinkContext.Provider>
  );
};

export default ManagementLayout;
